export const EXSBDELIVERY_DELETE_RESET = 'EXSBDELIVERY_DELETE_RESET'
export const EXSBDELIVERY_DELETE_SET_ERROR = 'EXSBDELIVERY_DELETE_SET_ERROR'
export const EXSBDELIVERY_DELETE_SET_DELETED = 'EXSBDELIVERY_DELETE_SET_DELETED'
export const EXSBDELIVERY_DELETE_TOGGLE_LOADING = 'EXSBDELIVERY_DELETE_TOGGLE_LOADING'
